import Segment from 'helpers/segment';

export const SCHEDULE_LIST_V2_EVENT = {
  CARD_CLICKED: 'Schedule card clicked',
  DISABLED_CARD_CLICKED: 'Disabled Schedule Clicked',
  EMPTY_DAY_CONTACT_US_CLICKED: 'No Schedules - Contact Us clicked',
  EMPTY_DAY_INTEGRATIONS_LINK_CLICKED: 'No Schedules - Integrations link clicked',
  EMPTY_DAY_MANAGE_CLICKED: 'No Schedules - Manage clicked',
  EMPTY_DAY_VIEWED: 'No Schedules Date viewed',
  FULL_TOOLTIP_HOVERED: 'Full tooltip hovered',
};

// Property keys below are the tracking-plan spelling agreed in the List TDD (ST-9010 §6.1).
// Renaming them to our camelCase convention would orphan the Segment/Amplitude reports.
export function trackScheduleCardClicked({
  classpassSpotsFull,
  clientWaiting,
  newUser,
  scheduleDateRange,
  scheduleId,
  smartspotOff,
  venueId,
}) {
  Segment.event(SCHEDULE_LIST_V2_EVENT.CARD_CLICKED, {
    SmartSpot_off: smartspotOff,
    classpass_spots_full: classpassSpotsFull,
    client_waiting: clientWaiting,
    new_user: newUser,
    schedule_date_range: scheduleDateRange,
    scheduleId,
    venueId,
  });
}

export function trackDisabledScheduleClicked({ scheduleId, venueId }) {
  Segment.event(SCHEDULE_LIST_V2_EVENT.DISABLED_CARD_CLICKED, { scheduleId, venueId });
}

export function trackFullTooltipHovered({ scheduleId, venueId }) {
  Segment.event(SCHEDULE_LIST_V2_EVENT.FULL_TOOLTIP_HOVERED, { scheduleId, venueId });
}

export function trackNoSchedulesDateViewed({ venueId }) {
  Segment.event(SCHEDULE_LIST_V2_EVENT.EMPTY_DAY_VIEWED, { venueId });
}

export function trackNoSchedulesManageClicked({ venueId }) {
  Segment.event(SCHEDULE_LIST_V2_EVENT.EMPTY_DAY_MANAGE_CLICKED, { venueId });
}

export function trackNoSchedulesIntegrationsLinkClicked({ venueId }) {
  Segment.event(SCHEDULE_LIST_V2_EVENT.EMPTY_DAY_INTEGRATIONS_LINK_CLICKED, { venueId });
}

export function trackNoSchedulesContactUsClicked({ venueId }) {
  Segment.event(SCHEDULE_LIST_V2_EVENT.EMPTY_DAY_CONTACT_US_CLICKED, { venueId });
}
